var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComments = function SvgComments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.317 0H2.257C1.016 0 .011.9.011 2L0 20l4.515-4h15.802c1.241 0 2.257-.9 2.257-2V2c0-1.1-1.016-2-2.257-2ZM4.515 7h13.544v2H4.515V7Zm9.03 5h-9.03v-2h9.03v2Zm4.514-6H4.515V4h13.544v2Z",
    fill: "#00104A"
  })));
};
export default SvgComments;